export default __webpack_public_path__ + "static/media/battery-off.66a3c847.svg";